import React from 'react';
import HeroSection from '../components/HeroSection';
import ProductCarousel from '../components/ProductCarousel';
import FeaturedProducts from '../components/FeaturedProducts';
import IngredientsOrigin from '../components/IngredientsOrigin';
import MembershipSection from '../components/MembershipSection';
import EyeCatchingDivider from '../components/EyeCatchingDivider';
import FragranceAlchemy from '../components/FragranceAlchemy';
import useScrollReveal from '../hooks/useScrollReveal';

/* Scroll reveal wrapper — Arabian-themed entrance animation */
const RevealSection = ({ children, id, dataSection, animation = 'rise', delay = 0 }) => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.08 });
  
  const animations = {
    rise: {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(60px)',
      transition: `opacity 0.9s ease-out ${delay}s, transform 0.9s ease-out ${delay}s`,
    },
    fadeScale: {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'scale(1)' : 'scale(0.95)',
      transition: `opacity 1s ease-out ${delay}s, transform 1s ease-out ${delay}s`,
    },
    slideLeft: {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateX(0)' : 'translateX(-50px)',
      transition: `opacity 0.9s ease-out ${delay}s, transform 0.9s ease-out ${delay}s`,
    },
    slideRight: {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateX(0)' : 'translateX(50px)',
      transition: `opacity 0.9s ease-out ${delay}s, transform 0.9s ease-out ${delay}s`,
    },
    unfurl: {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'scaleY(1)' : 'scaleY(0.6)',
      transformOrigin: 'top center',
      transition: `opacity 1s ease-out ${delay}s, transform 1s cubic-bezier(0.22,1,0.36,1) ${delay}s`,
    },
  };

  return (
    <div ref={ref} id={id} data-section={dataSection} style={animations[animation]}>
      {children}
    </div>
  );
};

const HomePage = () => {
  return (
    <div data-testid="home-page">
      
      {/* HERO — no animation, always visible */}
      <div id="section-hero" data-section="1-hero">
        <HeroSection />
      </div>
      
      {/* DIVIDER 1: GEOMETRIC */}
      <RevealSection id="divider-1" dataSection="divider-geometric-1" animation="fadeScale">
        <EyeCatchingDivider variant="geometric" />
      </RevealSection>
      
      {/* NEW ARRIVALS */}
      <RevealSection id="section-new-arrivals" dataSection="new-arrivals" animation="rise">
        <ProductCarousel
          endpoint="/products/new-arrivals/list"
          arabicTitle={'\u0648\u0635\u0644 \u062d\u062f\u064a\u062b\u0627\u064b'}
          kicker="FRESH FROM THE ATELIER"
          titleMain="NEW"
          titleAccent="ARRIVALS"
          quote={'"The newest treasures to cross the desert and reach our shelves..."'}
          showNewBadge
          sectionTestId="new-arrivals-section"
        />
      </RevealSection>
      
      {/* PRODUCT CAROUSEL */}
      <RevealSection id="section-carousel" dataSection="2-product-carousel" animation="rise">
        <ProductCarousel />
      </RevealSection>
      
      {/* BEST SELLERS (Men & Women) */}
      <RevealSection id="section-bestsellers" dataSection="3-best-sellers" animation="rise">
        <FeaturedProducts />
      </RevealSection>
      
      {/* FLOATING BOTTLES DIVIDER */}
      <RevealSection id="divider-2" dataSection="divider-bottles-1" animation="fadeScale">
        <EyeCatchingDivider variant="floating-bottles" />
      </RevealSection>
      
      {/* INGREDIENTS ORIGIN */}
      <RevealSection id="section-ingredients" dataSection="4-ingredients-origin" animation="slideLeft">
        <IngredientsOrigin />
      </RevealSection>
      
      {/* ARABIAN ARCH / TREASURY */}
      <RevealSection id="divider-3" dataSection="divider-arch" animation="unfurl">
        <EyeCatchingDivider variant="arabian-arch" />
      </RevealSection>
      
      {/* FRAGRANCE ALCHEMY (replaced Video Showcase) */}
      <RevealSection id="section-alchemy" dataSection="fragrance-alchemy" animation="fadeScale">
        <FragranceAlchemy />
      </RevealSection>
      
      {/* FLOATING BOTTLES DIVIDER */}
      <RevealSection id="divider-5" dataSection="divider-bottles-2" animation="fadeScale">
        <EyeCatchingDivider variant="floating-bottles" />
      </RevealSection>
      
      {/* MEMBERSHIP */}
      <RevealSection id="section-membership" dataSection="7-membership" animation="unfurl">
        <MembershipSection />
      </RevealSection>
      
    </div>
  );
};

export default HomePage;
